import React, { Component } from "react";
import Order from "../../components/Order/Order";
import axios from "../../api/axios-orders";
import Spinner from "../../components/Spinner/spinner";
import withErrorHandler from "../../hoc/withErrorHandler/withErroHandler";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
export class Orders extends Component {
  componentDidMount = () => {
    console.log(this.props);
    this.props.onFetchOrder(this.props.authToken, this.props.userId);
  };
  renderOrders = () => {
    const keys = Object.keys(this.props.orders);
    return Object.values(this.props.orders).map((order, index) => {
      return (
        <Order
          key={keys[index]}
          ingredients={order.ingredients}
          price={order.price}
          id={keys[index]}
        />
      );
    });
  };
  render() {
    let orders = <Spinner />;
    if (!this.props.loading) orders = this.renderOrders();
    return <div>{orders}</div>;
  }
}
const mapStateToProps = (state) => {
  return {
    loading: state.order.loading,
    orders: state.order.orders,
    authToken: state.auth.token,
    userId: state.auth.userId,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onFetchOrder: (authToken, userId) =>
      dispatch(actions.fetchOrders(authToken, userId)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Orders, axios));
